import { render, staticRenderFns } from "./transferInputRecord.vue?vue&type=template&id=37aee866&scoped=true"
import script from "./transferInputRecord.vue?vue&type=script&lang=js"
export * from "./transferInputRecord.vue?vue&type=script&lang=js"
import style0 from "./transferInputRecord.vue?vue&type=style&index=0&id=37aee866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aee866",
  null
  
)

export default component.exports